import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useTranslation } from "react-i18next";
import {
  EnumDeviceType,
  enumdevicetypeToI18nKey,
} from "../../../generated/enums";

const DEVICE_TYPE_STYLES: Record<
  EnumDeviceType,
  { icon: IconProp; className: string }
> = {
  serenity: {
    icon: "microchip",
    className: "bg-secondary text-secondary-text",
  },
  avitouch: {
    icon: "hand-pointer",
    className: "bg-tertiary text-secondary-text",
  },
  avibox: {
    icon: "box",
    className: "bg-warning text-secondary-text",
  },
  labelbox: {
    icon: "tag",
    className: "bg-grey-dark text-secondary-text",
  },
  vigebox: {
    icon: "cube",
    className: "bg-grey-medium text-secondary-text",
  },
};

export const DeviceTypeBadge = ({ type }: { type: EnumDeviceType }) => {
  const { t } = useTranslation();
  const style = DEVICE_TYPE_STYLES[type];

  return (
    <span
      className={`inline-flex items-center gap-2 px-2 py-0.5 rounded-full text-xs font-oxaniumMedium ${style.className}`}
    >
      <FontAwesomeIcon icon={style.icon} />
      <span>{t(enumdevicetypeToI18nKey[type])}</span>
    </span>
  );
};
